import script from "./SupplierView.vue?vue&type=script&setup=true&lang=js"
export * from "./SupplierView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__